/*
 * Copyright (C) 2020-present Borza LLC. All rights reserved.
 */

const SoldOut = () => (
  <p className="font-bold py-5 sm:text-left text-lg text-center text-red-500">
  <span className="whitespace-no-wrap">
    Sold Out
  </span>
</p>
);

export default SoldOut;
